<template>
  <div class="custom__class-code clearfix">
    <label :class="errorMessages.length ? 'error--text' : ''">{{
      title
    }}</label>
    <div class="custom__class-code-wrapper">
      <div
        class="custom__class-code-field"
        v-for="n in classCodeLength"
        :key="n"
      >
        <input
          ref="input"
          maxlength="1"
          autocorrect="off"
          autocomplete="off"
          autocapitalize="on"
          spellcheck="false"
          type="tel"
          class="form-control"
          v-model="classCode[n - 1]"
          @focus="setSelected"
          @blur="setFocus"
          @input.stop="inputEvent"
          @keydown.stop="downEvent"
          @keypress.stop="pressEvent"
          @paste="pasteEvent(n - 1, $event)"
        />
      </div>
    </div>
    <transition name="slide-y-transition" mode="out-in">
      <div
        v-show="errorMessages.length || hasFocus"
        :class="['messages', errorMessages.length ? 'error--text' : null]"
      >
        {{ errorMessages.length ? errorMessages[0] : hasFocus ? hint : '' }}
      </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: 'ClassCode',
  $_veeValidate: {
    // fetch the current value from the innerValue defined in the component data.
    // value () {
    //   return this.classCode.join('');
    // },
    name () {
      return 'class_code'
    }
  },
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    title: {
      type: String,
      default: 'Student Code'
    },
    blurOnComplete: {
      type: Boolean,
      default: false
    },
    classCodeLength: {
      type: Number,
      default: 4
    },
    errorMessages: {
      type: [String, Array],
      default: () => { return [] }
    },
    hint: {
      type: String
    }
  },
  data() {
    return {
      classCode: new Array(this.classCodeLength),
      hasFocus: false
    }
  },
  mounted() {
    if (this.value !== 0) {
      this.classCode = this.value
        .toString()
        .substr(0, this.classCodeLength)
        .split('')
    }
  },
  methods: {
    setFocus() {
      this.$nextTick(() => {
        if (!this.$refs.input)
          this.hasFocus = false
        let focus = false
        this.$refs.input.forEach((i) => {
          if (i === document.activeElement) {
            focus = true
          }
        })

        this.hasFocus = focus
        if (!focus)
          this.$validator.validate('class_code', this.classCode.join(''))
      })
    },
    inputEvent (event) {
      let value = event.target.value
      if (value.length > 1) {
        event.target.value = value.substr(0, 1)
      }
      this.getCodeString().length === this.classCodeLength
          ? (this.blurOnComplete ? event.target.blur() : this.nextElement(event))
          : event.target.value && this.nextElement(event)
    },
    pasteEvent (index, event) {
      let i,
        pasteData,
        elements = event.target.parentNode.parentNode.childNodes,
        len = 0,
        vm = this;
      for (event.clipboardData && event.clipboardData.getData
          ? pasteData = event.clipboardData.getData('Text')
          : window.clipboardData && window.clipboardData.getData && (pasteData = window.clipboardData.getData('Text'))
          , pasteData = pasteData.replace(/\s/g, '').substr(0, elements.length - index).split(''),
          i = 0; i < elements.length && pasteData[i]; i++) {
        len++
        elements[i + index].firstChild.value = pasteData[i]
        vm.classCode[i + index] = pasteData[i]
      }
      return [
        setTimeout(() => {
          vm.getCodeString().length === vm.classCodeLength
              ? (
                vm.blurOnComplete
                  ? event.target.blur()
                  : vm.previousElement(event, vm.getCodeString().length - 1)
              )
              : vm.previousElement(event, index + len)
          }, 0),
        event.preventDefault(),
        false
      ]
    },
    pressEvent (event) {
      let keyCode = event.which || event.keyCode
      return this.isMainKeyCode(keyCode)
          || this.isTab(keyCode)
          || this.isBackspace(keyCode)
          || this.isMetaKey(event, keyCode)
            ? void 0
            : (event.preventDefault(), false)
    },
    downEvent (event) {
      let parentNode = event.target.parentNode
      let keyCode = event.which || event.keyCode
      let _sibling
      if (keyCode === 8 && !event.target.value) {
        _sibling = parentNode.previousSibling
        if (_sibling && _sibling.firstChild && _sibling.firstChild.tagName === 'INPUT') {
          _sibling.firstChild.focus()
        }
      } else if (keyCode >= 37 && keyCode <= 41) {
        switch (keyCode) {
          case 37:
          _sibling = parentNode.previousSibling
          break
          case 39:
          _sibling = parentNode.nextSibling
          break
        }
        if (_sibling) {
          _sibling.firstChild.focus()
        }
        return [event.preventDefault(), false]
      }
    },
    previousElement (event, length) {
      let elements = event.target.parentNode.parentNode.childNodes
      if (length >= elements.length) {
        length = elements.length - 1
      }
      elements[length].firstChild.focus()
    },
    nextElement (event) {
      let parentNode = event.target.parentNode
      let nextSibling = parentNode.nextSibling
      nextSibling
          ? nextSibling.firstChild.focus()
          : parentNode.focus();
    },
    isMainKeyCode(keyCode) {
      let input = String.fromCharCode(keyCode)
      if (/[a-zA-Z0-9-_%\+#\$&@\!\?\^]/.test(input)) {
        return true
      } else {
        return false
      }
      // return keyCode >= 48 && keyCode <= 57
    },
    isTab(keyCode) {
      return keyCode === 9
    },
    isBackspace(keyCode) {
      return keyCode === 8
    },
    isMetaKey(event, keyCode) {
      return event.metaKey && keyCode === 118
    },
    setSelected(event) {
      this.hasFocus = true
      event.target.select()
    },
    getCodeString() {
      let code = this.classCode.join('')
      this.$emit('input', code)
      return code
    }
  }
}
</script>

<style lang="scss" scoped>
$size: 60px;
.custom__class-code {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  padding-top: 10px;

  .messages {
    text-align: left;
    font-size: 12px;
    padding-top: 5px;
    display: block;
    color: rgba(0,0,0,0.54);
  }

  label {
    display: block;
    text-align: left;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.54);
    padding-bottom: 5px;
    animation-duration: 0.6s;

    &.error--text {
      animation: shake 0.6s cubic-bezier(0.25, 0.8, 0.5, 1);
    }
  }

  &-wrapper {
    display: inline-block;
    min-width: 240px;
    text-align: center;
    @media only screen and (max-device-width: 736px) {
      max-width: 320px;
    }
    .custom__class-code-field {
      width: $size;
      display: inline-block;
      margin-right: 10px;
      float: left;
      @media only screen and (max-device-width: 736px) {
        float: none;
        margin-right: 4px;
      }
      .form-control {
        width: $size;
        height: $size;
        font-size: 40px;
        text-align: center;
        padding: 0;
        border: 1px solid rgba(0, 0, 0, 0.3);
        text-transform: capitalize;
        @media only screen and (max-device-width: 736px) {
          width: 42px;
          height: 42px;
          margin: 0;
        }
      }
    }
  }
}
</style>
